export class WhiteLabelProperties {
  logoUrl = '';
  highlightColor = '';
  enableHu = true;
  enableUvv = true;
  enableShowDrivingLicense = true;
  enableConfirmDrivingLicense = true;
}
